import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakcabs() {



  const cardData =
  {
    keyword: ' Pune to Ashtavinayak Cab',
    heading: 'Sai Trupti Cabs: Pune to Ashtavinayak Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Ashtavinayak cab services, designed to make your spiritual pilgrimage smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your journey. Every voyage is led by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way through the Ashtavinayak circuit. With transparent one-way or round-trip fares, flexible booking options (day-wise packages or full-itinerary trips), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Ashtavinayak convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Ashtavinayak with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Mayureshwar Temple, Morgaon",
    "description": "The Mayureshwar Temple at Morgaon, situated on the banks of the Karha River near Pune, is the first and foremost shrine in the Ashtavinayak Yatra. Dedicated to Lord Ganesha riding the peacock Mayur, the temple’s black stone architecture and walled courtyard radiate divine strength. Built in the 14th century by Morya Gosavi, it symbolizes wisdom and new beginnings. Pilgrims walk around the sacred enclosure containing idols of all eight Ganeshas, symbolizing the entire yatra. The rhythmic temple bells, fragrant incense, and chants of ‘Ganapati Bappa Morya’ make Morgaon the spiritual gateway to Maharashtra’s Ganesha devotion."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "Located on the banks of the Bhima River, Siddhivinayak Temple at Siddhatek is known as the powerful wish-fulfilling shrine of Lord Ganesha. Built during the Peshwa era, the temple sits atop a hillock surrounded by scenic views and lush greenery. Devotees perform a full circumambulation (pradakshina) of nearly 5 km around the hill to seek divine blessings. The idol, carved from a single black stone, faces north — a rare feature among Ganesha temples. The journey to Siddhatek through quiet villages and fields evokes both serenity and faith. Every visit leaves pilgrims humbled by peace and fulfillment."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "Ballaleshwar Temple in Pali, nestled in the Raigad district, is the only temple among the Ashtavinayak where Lord Ganesha is worshipped by the name of His devotee, Ballal. Built from pure stone and facing east, the temple is designed so that during sunrise, the first rays of the sun illuminate the idol. The architecture beautifully combines faith and astronomy. The nearby Dhundi Vinayak temple holds the original self-manifested (Swayambhu) idol. The village’s calm atmosphere, coconut groves, and temple bells create a soothing rhythm. Ballaleshwar represents devotion rewarded by divine love and eternal grace."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Varadvinayak Temple in Mahad near Khopoli stands as a symbol of generosity and blessing. Surrounded by a serene lake and forested hills, this temple’s idol is self-manifested (Swayambhu) and always bathed in oil — signifying prosperity and peace. Devotees can enter the sanctum and personally touch the idol, a unique privilege rare among other temples. Built in 1690 by Subhedar Ramji Mahadev Biwalkar, the temple exudes quiet elegance. With ringing bells, lotus ponds, and the fragrance of incense in the air, Mahad offers pilgrims a divine pause of reflection and fulfillment on their Ashtavinayak journey."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "Chintamani Temple in Theur, located 25 km from Pune, is one of the grandest and most visited Ashtavinayak temples. Here, Lord Ganesha is revered as the remover of worries — 'Chinta' meaning anxiety, and 'Mani' symbolizing the wish-fulfilling gem. The temple, built during the Peshwa era, features a towering gateway and peaceful courtyard. It was a favorite place of meditation for Shrimant Madhavrao Peshwa. Surrounded by riverbanks and greenery, the temple radiates calmness and positivity. Devotees come here seeking relief from troubles, leaving with hearts lightened and spirits renewed."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "Carved dramatically into a mountain cave complex in Lenyadri, the Girijatmaj Temple is a marvel of ancient rock-cut architecture. It is believed to be the birthplace of Lord Ganesha, born to Goddess Parvati (Girija) after her penance. The temple lies atop 307 stone steps and overlooks scenic valleys and rolling hills. Inside, the natural stone idol faces north and exudes a mysterious glow under oil lamps. The peaceful chants and echoing cave interiors create a deeply spiritual experience. Lenyadri beautifully unites divinity and nature — a place where faith meets the sky."
  },
  {
    "title": "Vighneshwar Temple, Ozar",
    "description": "Vighneshwar Temple in Ozar, located on the banks of the Kukadi River, is dedicated to Lord Ganesha as the remover of obstacles — 'Vighna-harta'. The temple’s elegant stone architecture and gold-plated dome shimmer under sunlight. Built during the reign of Chimaji Appa, it commemorates his victory over the Portuguese at Vasai Fort. The temple’s deepstambha (lamp tower) glows beautifully during evening aarti, and the peaceful river adds to the divine ambiance. Ozar represents triumph of good over adversity, making it a powerful and inspiring stop in the Ashtavinayak pilgrimage."
  },
  {
    "title": "Mahaganapati Temple, Ranjangaon",
    "description": "Mahaganapati Temple in Ranjangaon, near Shirur, completes the sacred circle of the Ashtavinayak Yatra. Lord Ganesha here is depicted as the most powerful form — Mahaganapati, seated with ten trunks and twenty arms. Built by Madhavrao Peshwa in the 18th century, the temple showcases impressive stone carvings and a grand sabha-mandap. It is believed that Lord Shiva worshipped Mahaganapati before his battle with the demon Tripurasura. The temple’s peaceful courtyard and distant farm fields create an atmosphere of divine completion and gratitude. Ending the yatra here fills devotees with deep satisfaction and spiritual contentment."
  }
],



  "services": [
    {
      "name": "Pune to Ashtavinayak Cab",
      "description": "Book a comfortable Pune to Ashtavinayak Cab for a sacred and seamless pilgrimage across Maharashtra’s eight revered Ganesh temples — Morgaon, Theur, Siddhatek, Ranjangaon, Ozar, Lenyadri, Mahad, and Pali. Our service includes experienced drivers, clean and well-maintained vehicles, and flexible packages. Choose from AC, Non-AC, Sedan, Ertiga, or Innova options for family or group travel. Enjoy door-to-door pickup, multiple route options, and safe, comfortable travel for your spiritual journey."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Service",
      "description": "Our Pune to Ashtavinayak Taxi Service is ideal for devotees seeking a reliable and comfortable ride to all eight Ganpati temples. We provide AC/Non-AC taxis, Innova, and Ertiga options with professional chauffeurs who know the Ashtavinayak route. Get affordable fares, on-time pickups, and custom itineraries designed for day trips or two-day pilgrimage tours. Whether solo or with family, we make your spiritual travel peaceful and hassle-free."
    },
    {
      "name": "Pune to Ashtavinayak Car Hire",
      "description": "Hire a car from Pune to Ashtavinayak for a convenient and flexible pilgrimage experience. Choose from Sedans, SUVs, or luxury vehicles to match your group size and comfort preferences. We offer customizable tour plans, affordable packages, and well-trained drivers familiar with all eight temple routes. Ideal for families, groups, or corporate devotees, our car hire service ensures your travel is smooth, devotional, and memorable."
    },
    {
      "name": "AC Cab Pune to Ashtavinayak",
      "description": "Travel in comfort with our AC Cab service from Pune to Ashtavinayak. Enjoy cool, relaxing rides while visiting all eight holy Ganesh temples across Maharashtra. Our AC cabs include Innova, Ertiga, and Sedans with ample legroom, clean interiors, and polite drivers. Perfect for long-distance spiritual travel, this service ensures peace of mind, safety, and a divine travel experience."
    },
    {
      "name": "Non AC Cab Pune to Ashtavinayak",
      "description": "For budget-conscious devotees, our Non-AC Cab from Pune to Ashtavinayak is the perfect option. Get reliable, clean vehicles with professional drivers who understand the temple routes. Ideal for small families or solo pilgrims, this service offers affordability without compromising comfort and punctuality."
    },
    {
      "name": "Innova Cab Pune to Ashtavinayak",
      "description": "Book an Innova Cab from Pune to Ashtavinayak for spacious, comfortable, and safe group travel. The Toyota Innova offers excellent legroom and luggage space, making it ideal for family pilgrimages or group tours. Travel to all eight temples with our experienced drivers who ensure you reach each destination smoothly and on time."
    },
    {
      "name": "Ertiga Cab Pune to Ashtavinayak",
      "description": "Our Ertiga Cab service from Pune to Ashtavinayak is perfect for families and small groups. This 7-seater vehicle offers both comfort and affordability with AC/Non-AC options. Enjoy smooth travel, professional drivers, flexible itineraries, and safe journeys to all the Ashtavinayak temples in one or two days."
    },
    {
      "name": "Luxury Cab Pune to Ashtavinayak",
      "description": "Travel in style with our Luxury Cab Service from Pune to Ashtavinayak. Choose from premium cars like Innova Crysta, Mercedes, or BMW for a comfortable and elegant pilgrimage. Enjoy plush interiors, AC comfort, and personalized service with chauffeurs trained to provide a peaceful, respectful experience for all devotees."
    },
    {
      "name": "Affordable Cab Pune to Ashtavinayak",
      "description": "Looking for an affordable way to visit all eight Ganpati temples? Our Pune to Ashtavinayak Cab Service offers the best prices with no hidden charges. Get AC or Non-AC cars, punctual drivers, and convenient booking options. Whether for individuals or groups, we make your sacred journey affordable, safe, and stress-free."
    },
    {
      "name": "Pune to Ashtavinayak Outstation Cab",
      "description": "Our Pune to Ashtavinayak Outstation Cab is designed for devotees planning overnight or extended trips. Cover all eight temples across Maharashtra at your own pace with flexible tour plans and clean vehicles. We ensure reliable outstation travel, experienced drivers, and affordable rates for a complete devotional experience."
    },
    {
      "name": "Pune to Ashtavinayak One Way Cab",
      "description": "Book a Pune to Ashtavinayak One Way Cab for direct travel to any of the Ashtavinayak temples. Ideal for devotees heading to a single destination, this service offers door-to-door pickup, punctuality, and flexible travel options at reasonable fares. Choose from AC/Non-AC, Sedan, or SUV options for a peaceful trip."
    },
    {
      "name": "Pune to Ashtavinayak Drop Cab",
      "description": "Hire our Pune to Ashtavinayak Drop Cab for one-way journeys with on-time service and courteous drivers. Enjoy clean, comfortable vehicles and easy booking for your visit to any of the eight Ganpati temples. Perfect for individuals or small families seeking dependable drop services."
    },
    {
      "name": "Corporate Cab Pune to Ashtavinayak",
      "description": "Our Corporate Cab Service from Pune to Ashtavinayak offers comfort and professionalism for business groups and corporate devotees. Enjoy luxury sedans or SUVs with well-trained chauffeurs, on-time pickup, and corporate billing options. Ideal for team pilgrimages or official religious tours."
    },
    {
      "name": "Wedding Cab Pune to Ashtavinayak",
      "description": "Add a spiritual touch to your wedding with our Pune to Ashtavinayak Wedding Cab Service. Choose from decorated luxury cars, Innovas, or Sedans for family or guest transport. Enjoy reliable service, professional drivers, and flexible bookings to visit Ganpati temples for blessings before or after your wedding."
    },
    {
      "name": "Online Cab Booking Pune to Ashtavinayak",
      "description": "Book your Pune to Ashtavinayak Cab Online with instant confirmation and multiple payment options. Choose from AC/Non-AC cars, Sedans, Innovas, or Ertigas at affordable prices. Our easy online booking system offers real-time support, transparent pricing, and flexible travel schedules for a hassle-free pilgrimage."
    }
  ],
  "tableData": [
    ["Pune to Ashtavinayak Cab", "Pune to Ashtavinayak Taxi Service"],
    ["Pune to Ashtavinayak Car Hire", "AC Cab Pune to Ashtavinayak"],
    ["Non AC Cab Pune to Ashtavinayak", "Innova Cab Pune to Ashtavinayak"],
    ["Ertiga Cab Pune to Ashtavinayak", "Luxury Cab Pune to Ashtavinayak"],
    ["Affordable Cab Pune to Ashtavinayak", "Pune to Ashtavinayak Outstation Cab"],
    ["Pune to Ashtavinayak One Way Cab", "Pune to Ashtavinayak Drop Cab"],
    ["Corporate Cab Pune to Ashtavinayak", "Wedding Cab Pune to Ashtavinayak"],
    ["Online Cab Booking Pune to Ashtavinayak", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Ashtavinayak Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Ashtavinayak temples — ideal for pilgrimage tours, family trips, and spiritual journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Ashtavinayak cab rides, ensuring affordable and stress-free travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from sedans, SUVs, Ertiga, Innova Crysta, or luxury cars to suit your group size, luggage, and comfort preferences for the Pune to Ashtavinayak route."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune–Ashtavinayak routes, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Pune and drops at any of the eight Ashtavinayak temples or nearby locations."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for long-distance spiritual travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and any queries for your Pune to Ashtavinayak trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Ashtavinayak cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]


















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Ashtavinayak cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Ashtavinayak cab services for one-way, round trips, and group pilgrimage tours.',
  },
  {
    question: 'How can I book a Pune to Ashtavinayak cab with Sai Trupti Cabs?',
    answer: 'You can book your Pune to Ashtavinayak cab easily through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Ashtavinayak?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Ashtavinayak trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance and pilgrimage travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Ashtavinayak for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group pilgrimages, and leisure travel from Pune to Ashtavinayak temples.',
  },
  {
    question: 'Is the Pune to Ashtavinayak cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Ashtavinayak trips for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Ashtavinayak cab fares?',
    answer: 'Our cab fares start from ₹2,500 for sedans, ₹3,500–₹5,000 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Ashtavinayak cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Ashtavinayak cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Ashtavinayak cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Ashtavinayak cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'I booked a Pune to Ashtavinayak cab with Sai Trupti Cabs. The driver was punctual and the journey was smooth and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Joshi',
    feedback: 'Excellent service for our Ashtavinayak pilgrimage. Sai Trupti Cabs made the trip hassle-free and enjoyable.',
    rating: 5,
  },
];















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Ashtavinayak Darshan Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-ashtavinayak-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Ashtavinayak darshan cab service with complete temple tour packages. Book one day or two day Ashtavinayak trip with Innova Crysta, Ertiga, sedan and SUV options. Safe, comfortable and affordable pilgrimage travel with experienced drivers.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Ashtavinayak"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "9320"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-ashtavinayak-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Ashtavinayak Darshan Cab | 1 Day Package ₹2999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Ashtavinayak darshan cab package at ₹2999 with Sai Trupti Cabs. 1 day & 2 day temple tour, Innova Crysta, Ertiga, sedan & SUV available. Safe and comfortable pilgrimage cab service." 
  />

  <meta 
    name="keywords" 
    content="pune to ashtavinayak cab, ashtavinayak darshan cab pune, pune to ashtavinayak package, ashtavinayak tour cab, pune to ashtavinayak taxi, ashtavinayak one day trip cab, ashtavinayak darshan package from pune, pune to ashtavinayak innova crysta, ashtavinayak ertiga cab, ashtavinayak sedan cab, ashtavinayak round trip cab, cheap ashtavinayak cab pune, best cab service ashtavinayak darshan, ashtavinayak temple tour cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoashtavinayakcabs;